
















import { debounce } from 'lodash'
export default {
  name: 'DatasetSearch'
  props: {
    # dataset component
    dataset: { type: Object, default: -> null }
  }
  data: -> {
    isTyping: no
  }
  computed: {
    isLoading: -> this.isTyping or this.dataset.loading
  }
  methods: {
    # tell about search content to outside component
    # for now this logic just for quick demo.
    onType: (e) -> (
      this.isTyping = yes
      this.onSearch(e)
    )
    onSearch: (e) -> (
        keyword = e.target.value
        
        # remove transpile data method when no searching
        if not keyword? or keyword.trim().length is 0
          this.dataset.transpileData = (v) -> v
          this.dataset.forceFetch()
          this.isTyping = no
          return yes
        # create regex intance
        g = new RegExp keyword.toLowerCase(), 'g'
        # replace transpile method with filter
        this.dataset.transpileData = (data) -> (
          #console.log 'transpile'
          getValueList = (n) -> Object.values(n).map (m) -> if m then m.toString().toLowerCase() else null
          data.filter (row) -> (
            #console.log row
            # extract value of row to list
            valueList = getValueList row
            # compare every value in row
            valueList.some (n) -> g.test n
          )
        )
        # force reload
        this.dataset.forceFetch()
        this.isTyping = no
      )
  }
}
